import { legacy } from '@/shared/api/client';

export interface SurveySettingsPayload {
  hasSurvey: boolean;
  idSurvey?: string;
  messageSurvey?: string;
  titleLinkSurvey?: string;
}

/** Persiste a pesquisa NPS da loja (PUT /passbook/:id/survey). */
export async function updateSurveySettings(
  idPassbook: string,
  payload: SurveySettingsPayload,
): Promise<void> {
  await legacy.put<{ ok: boolean }>(`/passbook/${idPassbook}/survey`, payload, {
    headers: { 'X-Passbook-Id': idPassbook },
  });
}
